module.exports = __webpack_public_path__ + "img/WhereIsDateCode.a9f10262.png";